export function localizeMarketplaceIntelligenceLimitation(value: string): string {
  if (value.startsWith('No barcode, manufacturer article, model')) {
    return 'Нет штрихкодов, артикулов производителя, моделей или структурированных характеристик в публичной выдаче. В v1 межплощадочное сопоставление SKU остаётся внутренней задачей и не публикуется в отчёте.';
  }
  if (value.startsWith('Availability is derived') || value.startsWith('Availability is uneven')) {
    return 'Наличие считается по сигналам, доступным в источнике; для заблокированных вызовов и скрытых полей отчёт показывает ограничение качества данных.';
  }
  if (value.startsWith('The current artifact is one collection date')) {
    return 'Текущая публикация содержит одну дату сбора, поэтому ценовые, ранговые и динамические сигналы отзывов появятся после накопления ежедневной истории.';
  }
  return value;
}
